import classNames from 'classnames';
import { Stack } from '@legacy/components/mui-components';
import { HeaderTitle } from './components/HeaderTitle';
import { MenuButton } from './components/MenuButton';
import { BookmarkButton } from './components/BookmarkButton';
import styles from './ScreenHeader.module.scss';
import { useHasNewNavigation } from '@/hooks/featureFlags';

interface ScreenHeaderProps {
  urlForTest?: string;
}

export default ({ urlForTest }: ScreenHeaderProps) => {
  const hasNewNavigation = useHasNewNavigation();

  return (
    <div
      data-automation-id="ScreenHeader"
      className={classNames(styles.ScreenHeaderContainer, {
        [styles.IsInNewNavigation]: hasNewNavigation,
      })}
    >
      <Stack direction="row" alignItems="center">
        <HeaderTitle />
        <Stack direction="row" alignItems="center" gap={0}>
          <BookmarkButton />
          <MenuButton urlForTest={urlForTest} />
        </Stack>
      </Stack>
    </div>
  );
};
